import { render, staticRenderFns } from "./Legado.vue?vue&type=template&id=46737462&scoped=true"
import script from "./Legado.vue?vue&type=script&lang=js"
export * from "./Legado.vue?vue&type=script&lang=js"
import style0 from "./Legado.vue?vue&type=style&index=0&id=46737462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46737462",
  null
  
)

export default component.exports